import React, { lazy, Suspense } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import ScrollToTop from './components/ScrollToTop';
import './App.css';

import HomePage from './pages/HomePage';
import { MARKETS } from './data/services.mjs';
const FacturacionPage = lazy(() => import('./pages/facturacion/FacturacionPage'));
const ServicesIndexPage = lazy(() => import('./pages/services/ServicesIndexPage'));
const ServicePage = lazy(() => import('./pages/services/ServicePage'));
const ProductsPage = lazy(() => import('./pages/products/ProductsPage'));
const PoliticaPrivacidad = lazy(() => import('./pages/legal/PoliticaPrivacidad'));
const PoliticaCookies = lazy(() => import('./pages/legal/PoliticaCookies'));
const TerminosDeUso = lazy(() => import('./pages/legal/TerminosDeUso'));
const Soporte = lazy(() => import('./pages/legal/Soporte'));
const PoliticaContingencia = lazy(() => import('./pages/legal/PoliticaContingencia'));
const NotFoundPage = lazy(() => import('./pages/notfound/NotFoundPage'));

// Al agregar una ruta aquí, agrégala también en src/seo/routes.mjs (sitemap + prerender).
const App = () => {
    return (
        <BrowserRouter>
            <ScrollToTop />
            <Suspense fallback={<div className="text-center py-5"><div className="spinner-border" role="status"><span className="sr-only">Cargando...</span></div></div>}>
                <Routes>
                    <Route path="/" element={<HomePage />} />
                    <Route path="/facturacion-electronica" element={<FacturacionPage />} />
                    {/* /servicios, /latam/servicios, /us/servicios (+ /:slug) — un par de rutas por mercado */}
                    {Object.values(MARKETS).map((m) => (
                        <React.Fragment key={m.code}>
                            <Route path={`${m.pathPrefix}/servicios`} element={<ServicesIndexPage market={m.code} />} />
                            <Route path={`${m.pathPrefix}/servicios/:slug`} element={<ServicePage market={m.code} />} />
                        </React.Fragment>
                    ))}
                    <Route path="/productos" element={<ProductsPage />} />
                    <Route path="/politica-privacidad" element={<PoliticaPrivacidad />} />
                    <Route path="/politica-cookies" element={<PoliticaCookies />} />
                    <Route path="/terminos-de-uso" element={<TerminosDeUso />} />
                    <Route path="/soporte" element={<Soporte />} />
                    <Route path="/politica-de-contingencia" element={<PoliticaContingencia />} />
                    <Route path="*" element={<NotFoundPage />} />
                </Routes>
            </Suspense>
        </BrowserRouter>
    );
};

export default App;
